import React from 'react'
import { FormikProvider, useFormik } from 'formik'
import { useTranslation } from 'react-i18next'

import { Category } from '../../models/Category'
import useCreateCategory from '../../state/mutations/useCreateCategory'
import setFormErrors from '../../utilities/setFormErrors'
import useFocusInputWithError from '../../utilities/useFocusInputWithError'
import FormButtons from '../basics/FormButtons/FormButtons'
import { MarkdownEditorFormik } from '../basics/MarkdownEditor/MarkdownEditor'
import { TextInputFormik } from '../basics/TextInput/TextInput'

import styles from './EditCategoryForm.module.scss'

// TODO: Does only allow creating categories for now, editing TBD

type EditCategoryFormProps = {
  onClose?(category?: Category): void
}

export default React.memo(function EditCategoryForm({ onClose }: EditCategoryFormProps) {
  const { t } = useTranslation()

  const createCategory = useCreateCategory()
  const formik = useFormik({
    initialValues: { name: '' },
    enableReinitialize: true,
    onSubmit: async (values, { setStatus, setErrors }) => {
      try {
        setStatus()

        const category = await createCategory.mutateAsync(values)

        onClose?.(category)
      } catch (err) {
        setFormErrors({ setStatus, setErrors, t }, err)
      }
    },
  })

  useFocusInputWithError(formik)

  return (
    <FormikProvider value={formik}>
      <form noValidate onSubmit={formik.handleSubmit} className={styles.EditCategoryForm}>
        <h1>{t('category.create new category')}</h1>

        <TextInputFormik name="name" label={t('category.field name')} required />
        <TextInputFormik name="shortDescription" label={t('category.field shortDescription')} />
        <MarkdownEditorFormik name="longDescription" label={t('category.field longDescription')} />

        <FormButtons {...formik} onClose={() => onClose?.()} />
      </form>
    </FormikProvider>
  )
})
